<script lang="ts">
    export let width = 26;
    export let strokeWidth = 1;
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} viewBox="0 0 26 27" class="fill-none" stroke="currentColor" stroke-width={strokeWidth}>
    <circle  cx="10.7152" cy="10.6863" r="9.9051" />
    <path  d="M17.1057 18.5039L24.8961 26.2943" />
</svg>
